import { render } from "./LegacyAppHeader.vue?vue&type=template&id=7912bea4"
import script from "./LegacyAppHeader.vue?vue&type=script&lang=js"
export * from "./LegacyAppHeader.vue?vue&type=script&lang=js"

import "./LegacyAppHeader.vue?vue&type=style&index=0&id=7912bea4&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.11.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__